module.exports = __webpack_public_path__ + "img/image-10.51a26c52.jpg";